import { OccupancyType, PropertyType } from 'constants/loanApplication';

export const checkIsMixedUseVisible = ({ occupancy, propertyType }) => {
  return (
    [OccupancyType.PRIMARY_RESIDENCE, OccupancyType.SECOND_HOME].includes(occupancy) &&
    propertyType === PropertyType.SINGLE_FAMILY
  );
};

export const checkIsMixedUseVisiblePendingChange = ({ pendingChanges }) => {
  return !(
    [undefined, OccupancyType.PRIMARY_RESIDENCE, OccupancyType.SECOND_HOME].includes(
      pendingChanges?.occupancy?.newValue,
    ) || [undefined, PropertyType.SINGLE_FAMILY].includes(pendingChanges?.propertyType?.newValue)
  );
};

export const checkIsManufacturedHome = propertyType => {
  return propertyType === PropertyType.MANUFACTURED_HOME;
};

export const checkIsManufacturedHomePendingChange = ({ pendingChanges }) => {
  return ![undefined, PropertyType.MANUFACTURED_HOME].includes(
    pendingChanges?.propertyType?.newValue,
  );
};
